export const mapFiltersToAlgoliaFilters = (
  filters: Record<string, string[] | number[] | boolean>
): string =>
  Object.entries(filters)
    .map(([key, value]) =>
      typeof value === 'boolean'
        ? `${key}:${value}`
        : value.length
          ? `(${value.map((v) => `${key}:"${v}"`).join(' OR ')})`
          : ''
    )
    .filter((v) => !!v)
    .join(' AND ')
